import React, { PropTypes, PureComponent } from 'react';
import RcSlider from 'rc-slider';
import dateformat from 'dateformat';

import classNames from 'classnames';
import 'rc-slider/assets/index.css';
import '../controls.scss';

const startStyle = {
  fontSize: '1em',
  color: '#00489a',
  height: '4px',
  right: 'auto',
  left: 0,
};

const endStyle = {
  width: 'auto',
  fontSize: '1em',
  color: '#00489a',
  left: 'auto',
  height: '4px',
  right: 0,
}

class Slider extends PureComponent {
  constructor(props) {
    super(props);
    this.marks = {
      0: {
        style: startStyle,
        label: dateformat(new Date(props.min), props.format || 'HH:MM')
      },
      100: {
        style: endStyle,
        label: dateformat(new Date(props.max), props.format || 'HH:MM')
      }
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      nextProps.min !== this.props.min &&
      nextProps.max !== this.props.max
    );
    return true;
  }

  componentWillReceiveProps(nextProps) {
    this.marks = {
      0: {
        style: startStyle,
        label: dateformat(new Date(nextProps.min), nextProps.format || 'HH:MM')
      },
      100: {
        style: endStyle,
        label: dateformat(new Date(nextProps.max), nextProps.format || 'HH:MM')
      }
    };
  }

  render() {
    const { handler, visibleTimestamp, isPlaying, initial, min, max, step, prognoseAfterTimestamp } = this.props;
    const sliderStyles = classNames({
      'mt-slider-animated': isPlaying,
      'mt-prognose': prognoseAfterTimestamp && prognoseAfterTimestamp < visibleTimestamp,
    });

    return (
      <div>
        {prognoseAfterTimestamp !== null ?
          <div>
            <div className="mt-slider-text-label mt-slider-text-label-prognose" style={{ left: `${((prognoseAfterTimestamp - min) * 100) / (max - min)}%` }}>Prognose</div>
          </div>
        :
          null
        }
        <RcSlider
          className={sliderStyles}
          min={min}
          max={max}
          marks={this.marks}
          step={step}
          onChange={handler}
          tipFormatter={null}
          defaultValue={initial}
          value={visibleTimestamp}
        />
      </div>
    );
  }
}

Slider.propTypes = {
  initial: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  handler: PropTypes.func,
  format: PropTypes.string,
  currentTimestamp: PropTypes.number,
  tilesLoadStatus: PropTypes.number
};

export default Slider;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimeNavigation/controls/Slider.js
 **/